import { render, staticRenderFns } from "./circle.vue?vue&type=template&id=12ec0f84&scoped=true&"
import script from "./circle.vue?vue&type=script&lang=js&"
export * from "./circle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ec0f84",
  null
  
)

export default component.exports